import { render } from "./retailGroupPopup.vue?vue&type=template&id=48fb0348&scoped=true"
import script from "./retailGroupPopup.vue?vue&type=script&lang=js"
export * from "./retailGroupPopup.vue?vue&type=script&lang=js"

import "./retailGroupPopup.vue?vue&type=style&index=0&id=48fb0348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fb0348"]])

export default __exports__